import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { duplicateDashboardButtonActions } from "app/static/frontend/dashboards/action-creators"
import { Button } from "@quorumus/plum"
import { Icon } from "@/components"
import { duplicateRowActionConnection } from "sheets/components/cells/action-buttons/selectors"

export const DuplicateDashboardAction = ({ icon, text, id, duplicateDashboardFromListView }) => (
    <Button
        dataCy="duplicate-dashboard"
        leftIcon={icon}
        leftSection={<Icon icon={icon} iconFamily="fas" />}
        onClick={duplicateDashboardFromListView(id)}
        variant="tertiary"
    >
        {text}
    </Button>
)

DuplicateDashboardAction.propTypes = {
    fields: PropTypes.object.isRequired,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    duplicateDashboardFromListView: PropTypes.func.isRequired,
}

export default connect(
    (state, props) => duplicateRowActionConnection(state, props),
    duplicateDashboardButtonActions,
)(DuplicateDashboardAction)
